import { Component, Input, OnInit } from '@angular/core';
import { CallsService } from '../controller/calls.service';
import { NotificationService } from '../services/notification/notification.service';
import { interval, Observable, of, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { State } from '../models/state.model';
import { ImportAction } from '../actions/import.actions';
import { RepairOrderService } from '../services/repair-order/repair-order.service';
import { catchError, switchMap, takeWhile } from 'rxjs/operators';
interface importState {
  showImporting: boolean;
  showIcon: boolean;
  text: string;
  success: boolean
  error: boolean
  downloadIcon: boolean,
  downloadIcon2: boolean,
  modalTitle: string,
  generateFile: boolean,
  downloadAttachmentFileUrl: string,
  adasThirdPartyJobId?: string
  apiData?: any,
  roId?: string
}

@Component({
  selector: 'app-global-popup',
  templateUrl: './global-popup.component.html',
  styleUrls: ['./global-popup.component.scss']
})
export class GlobalPopupComponent implements OnInit {
  importingState: importState
  equipment$: Observable<any>;
  @Input() title: string = "Import Tools";
  @Input() exportAttachmentUrl: string = "";
  pollingSub: Subscription;

  constructor(public notification: NotificationService,
    public call: CallsService,
    public repairOrderService: RepairOrderService,
    private store: Store<State>,
  ) {
  }

  ngOnInit(): void {
    this.call.channel = new BroadcastChannel('collabtic_channel');
    this.call.channel.onmessage = (event) => {
      if (event.data.callAccepted || event.data.callRejected) {
        this.notification.videoCall = false;
        this.notification.incomingCallRing.pause();
      }
    }

    this.equipment$ = this.store.select((store) => store.importing);
    this.equipment$.subscribe((res) => {
      this.importingState = res;
      this.title = this.importingState?.modalTitle
      this.exportAttachmentUrl = res?.downloadAttachmentFileUrl

      if (this.importingState.adasThirdPartyJobId) {
        if (!this.importingState.showImporting) {
          this.importingState.adasThirdPartyJobId = '';
        } else {
          this.chatbotExtractAdasReport();
        }
      }
    })

  }

  chatbotExtractAdasReport() {
    if (this.pollingSub) {
      this.pollingSub.unsubscribe();
      this.pollingSub = null;
    }

    this.pollingSub = interval(3000)
      .pipe(
        switchMap(() =>
          this.repairOrderService.chatbotExtractAdasReport(this.importingState.adasThirdPartyJobId).pipe(
            catchError(err => {
              console.error('Polling error:', err);
              return of({ status: 'error', response: null });
            })
          )
        ),
        takeWhile((response: any) => response?.status === 'processing', true)
      )
      .subscribe({
        next: (res: any) => {
          console.log('Status:', res.status);

          if (res.status === 'completed') {
            const apiFormData = new FormData();
            const apiData = this.importingState.apiData;

            apiFormData.append("apiKey", apiData?.apiKey);
            apiFormData.append("domainId", apiData?.domainId);
            apiFormData.append("userId", apiData?.userId);
            apiFormData.append("roId", apiData?.roId);
            apiFormData.append("id", apiData?.id);
            apiFormData.append("action", 'reportData');
            apiFormData.append("reportData", JSON.stringify(res.response));

            this.repairOrderService.manageAdasThirdParty(apiFormData).subscribe((resp) => {
              let responseData = resp?.data;
              let serviceData = {
                reportData: res.response,
                roMapData: responseData?.roMapData
              };
              this.repairOrderService.setAdasThirdPartyData(serviceData);
              this.repairOrderService.setAdasThirdPartyDataRo(serviceData);
              this.store.dispatch(
                new ImportAction({
                  showImporting: false,
                  showIcon: false,
                  text: '',
                  error: false,
                })
              );
            });
          } else if (res.status === 'error') {
            console.warn('Polling returned error status.');
            this.repairOrderService.setAdasThirdPartyData(null);
            this.repairOrderService.setAdasThirdPartyDataRo(null);
            this.store.dispatch(
              new ImportAction({
                showImporting: false,
                showIcon: false,
                text: '',
                error: false,
              })
            );
          }
        },
        error: (err) => {
          console.error('Polling failed:', err);
        },
        complete: () => {
          console.log('✅ Polling complete or stopped.');
          this.pollingSub = null;
        }
      });
  }

  acceptCall(): void {
    this.notification.videoCall = false;
    this.notification.incomingCallRing.pause();
    setTimeout(() => {
      const aurl = 'video-call';
      window.open(aurl, '_blank' + aurl).focus();
    }, 10);
    this.call.channel.postMessage({
      callAccepted: true
    })
  }

  rejectCall(): void {
    this.notification.videoCall = false;
    this.notification.videoCallData = null;
    this.call.incomingCall = false;
    this.call.outgoingCall = false;
    this.notification.incomingCallRing.pause();
    this.call.channel.postMessage({
      callRejected: true
    })
  }

  endCall() {
    this.call.outgoingCall = false;
    this.call.outgoingCallRing?.pause();
    localStorage.removeItem('videoCallDataSessionId');
    localStorage.removeItem('videoCallDataToken');
    localStorage.removeItem('videoCallUserId');
  }

  onClose() {
    this.store.dispatch(
      new ImportAction({
        showImporting: false,
        showIcon: false,
        text: '',
        error: false,
      })
    );
  }

  onCancelRO() {

  }
}